import { FixMeLater } from './misc';

export type TransitionDuration = { enter: number; exit: number };

export const reflow = (node: Element): number => node.scrollTop;

export function getAutoAnimationDuration(distance: number | null): number {
    if (!distance) {
        return 0;
    }

    const constant = distance / 36;
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}

export type BaseTransitionProps = {
    /**
     * If `true` and `in` is also `true`, the enter transition will be performed on mount.
     * Set this to `false` to disable this behavior.
     * @default true
     */
    appear?: boolean;

    /**
     * If `true`, the component will transition in.
     */
    in?: boolean;

    onEnter?: (isAppearing: boolean) => void;

    onEntered?: () => void;

    onEntering?: (isAppearing: boolean) => void;

    onExit?: () => void;

    onExited?: () => void;

    onExiting?: () => void;

    /**
     * Permit additional properties which will be passed to the root node.
     */
    [x: string]: FixMeLater;
};
